<app-sidenav>
  <app-header *ngIf="isAuthenticated$ | async" />
  <div class="main" [ngStyle]="mainStyles$ | async">
    <app-loader></app-loader>
    <!-- Faixa de RPA parado: some sozinha quando a empresa selecionada
         nao tem automacao com problema (ver AvisoRpaComponent). Fica FORA de
         .content: la dentro todo filho ganha flex-grow (styles.scss) e a faixa,
         mesmo vazia, dividia a largura com a pagina e empurrava a tela para a
         direita (18/09 a 25/09/2026). -->
    <app-aviso-rpa *ngIf="isAuthenticated$ | async" />
    <div class="content" >
      <router-outlet />
    </div>
    <app-footer />
  </div>
</app-sidenav>
